var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33073 16.6667H16.6641C17.1061 16.6667 17.53 16.4911 17.8426 16.1785C18.1551 15.866 18.3307 15.442 18.3307 15V6.66667C18.3307 6.22464 18.1551 5.80072 17.8426 5.48816C17.53 5.17559 17.1061 5 16.6641 5H10.0557C9.78122 4.99858 9.51131 4.92937 9.26998 4.79853C9.02865 4.66769 8.82338 4.47927 8.6724 4.25L7.98906 3.25C7.83808 3.02073 7.63281 2.83231 7.39148 2.70147C7.15015 2.57063 6.88024 2.50142 6.60573 2.5H3.33073C2.8887 2.5 2.46478 2.67559 2.15222 2.98816C1.83966 3.30072 1.66406 3.72464 1.66406 4.16667V15C1.66406 15.9167 2.41406 16.6667 3.33073 16.6667Z",
    stroke: "#EB6D26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.33594V13.3359",
    stroke: "#EB6D26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.8359L10 8.33594L12.5 10.8359",
    stroke: "#EB6D26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/Import.82816c59895510c1a0bf44d4f9ce7fe5.svg";
export { ForwardRef as ReactComponent };